import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { VirtualScrollerModule } from 'primeng/virtualscroller';

import { HeaderComponent } from './header/header.component';
import { LoadingImageModule } from './loading-image/loading-image.module';
import { NotificationDetailsComponent } from './notification-details/notification-details.component';
import { PreviewAlertComponent } from './preview-alert/preview-alert.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
    imports: [RouterModule, CommonModule, TranslateModule, LoadingImageModule, ConfirmDialogModule, DialogModule, OverlayPanelModule, VirtualScrollerModule, DynamicDialogModule],
    providers: [ConfirmationService, DialogService],
    declarations: [HeaderComponent, SidebarComponent, NotificationDetailsComponent, PreviewAlertComponent],
    exports: [HeaderComponent, SidebarComponent, NotificationDetailsComponent]
})
export class SharedModule {}
